import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const AnalyticsTracker = () => {
    const location = useLocation();
    useEffect(() => {
        // Send a pageview event to Google Analytics each time the location changes
        ReactGA.send({hitType: 'pageview', page: location.pathname});
    }, [location]);
  return null;
}

export default AnalyticsTracker